import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Flex from './common/Flex';

const getCircleStackIcon = (icon, transform) => (
	<span className='fa-stack ms-n1 me-3'>
		<FontAwesomeIcon icon='circle' className='text-200 fa-stack-2x' />
		<FontAwesomeIcon icon={icon} transform={transform ?? ''} className='text-primary fa-stack-1x' inverse />
	</span>
);

const EventModalMediaContent = ({ icon, heading, headingAction, content, children }) => (
	<Flex className='mt-3'>
		{getCircleStackIcon(icon)}
		<div className='flex-1 min-w-0'>
			<div className='d-flex align-items-center flex-wrap gap-2 mb-2'>
				<h6 className='mb-0 flex-shrink-0'>{heading}</h6>
				{headingAction ? (
					<>
						<div className='flex-grow-1 border-bottom border-200' style={{ minWidth: '2rem' }} />
						<div className='flex-shrink-0'>{headingAction}</div>
					</>
				) : null}
			</div>
			{children || <p className='mb-0 text-justify'>{content}</p>}
		</div>
	</Flex>
);

export default EventModalMediaContent;
